export enum WordColorStroopColor {
  Red = 'red',
  Green = 'green',
  Blue = 'blue',
  Brown = 'brown',
  Purple = 'purple'
}

export interface WordColorStroopItem {
  color: WordColorStroopColor;
  stimulus: string;
  time: number;
}

export const colorMap: Record<WordColorStroopColor, string> = {
  [WordColorStroopColor.Red]: 'red',
  [WordColorStroopColor.Green]: 'green',
  [WordColorStroopColor.Blue]: 'blue',
  [WordColorStroopColor.Brown]: 'brown',
  [WordColorStroopColor.Purple]: 'purple'
};

